import store from "@/services/store";
function list_names(list,id)
{
	if(list!==null && list!=='')
	{
			if( store.state.crudStore.lists[list].filter( list => { 
					return ( list.id.toString()=== id.toString() && id!='' ) || ( list.name.toString()=== id.toString() && id!='' ) } ))
			{
					return store.state.crudStore.lists[list].filter( list => {return list.id.toString()=== id.toString() || list.name.toString()=== id.toString() })[0].name 
			}

	}
	return ''  
}
export default {
	data(){
		return {
			tableAlertClass: function (items){ if(items.servicios_activos.length===1){return true}else if(items.servicios_nuevos.length>0) {return true }else {return false} },
			tableAlertText: function (items){ if(items.servicios_nuevos.length>0){let name = 'El afiliado tiene los servicios de ';for (let i = 0; i < items.servicios_nuevos.length; i++) { name += items.servicios_nuevos[i].name+', ';} return name+' pendientes del radicado de afiliación.' } return null },

			tableGBoptions: { 
				options: {editar: 'Editar Aporte del Afiliado'},
			},

			tableGBSearch: ['datos_afiliado/documento','datos_afiliado/name','list_novedad/name'],
			
			tableGBItems: [
				{
					thead: { th: 'Documento', btn: 'Generar', msjBtn: 'Generar archivo plano'},
					tbody: { td: ['datos_afiliado/tipodocumento','datos_afiliado/documento'],campos: ['info_afiliacion/id','servicios_activos','servicios_nuevos']}
				},
				{
					thead: { th: 'Nombres', sort: null, sortTable: 'datos_afiliado/name',},
					tbody: { td: ['datos_afiliado/name']}
				},
				{
					thead: { th: 'Eps', },
					tbody: { td: ['servicios_activos'], ftn: function (value){ let eps = value.filter(list => list.name==='Eps'); if(eps.length>0) { return list_names(eps[0].name_list,eps[0].id_list) } return '' }}
				},
				{
					thead: { th: 'Riesgo', },
					tbody: { td: ['servicios_activos'], ftn: function (value){ let eps = value.filter(list => list.name==='Riesgo'); if(eps.length>0) { return list_names(eps[0].name_list,eps[0].id_list) } return '' }}
				},
				{
					thead: { th: 'Ccf', },
					tbody: { td: ['servicios_activos'], ftn: function (value){ let ccf = value.filter(list => list.name==='Ccf'); if(ccf.length>0) { return list_names(ccf[0].name_list,ccf[0].id_list) } return '' }}
				},
				{
					thead: { th: 'Afp', },
					tbody: { td: ['servicios_activos'], ftn: function (value){ let Afp = value.filter(list => list.name==='Afp'); if(Afp.length>0) { return list_names(Afp[0].name_list,Afp[0].id_list) } return '' }}
				},
				{
					thead: { th: 'Otros', },
					tbody: { td: ['servicios_activos'], ftn: function (value){ let name='';for(let i=0;i<value.length;i++){ if(value[i].nota_delete===null && value[i].name!=='Administración' && value[i].name!=='Eps' && value[i].name!=='Riesgo' && value[i].name!=='Ccf' && value[i].name!=='Afp'){name=name+' '+value[i].name; }} return name}}
				},
				{
					thead: { th: 'Periodo', },
					tbody: { td: ['info_afiliacion/mes_periodo','info_afiliacion/ano_periodo']}
				},
				{
					thead: { th: 'Salario', },
					tbody: { td: ['info_afiliacion/salario']}
				},
				{
					thead: { th: 'Nov.', sort: null, sortTable: 'info_afiliacion/id_list_novedad', },
					tbody: { td: ['list_novedad/name']}
				},
			],			
		
		}
	},
}